/* eslint-disable no-debugger */
import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  isLoading: false,
  error: '',
  projectMsg: '',
  status: true,
  createProjectStatus: false,
  projectList: [],
  clientListByProject: [],
  disableProjectList: []
};

const slice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // RESET MSG
    resetProjectMsg(state) {
      state.projectMsg = '';
    },
    // RESET ERROR
    resetProjectError(state) {
      state.error = '';
    },
    // RESET CREATE STATUS
    resetCreateProjectStatus(state) {
      state.createProjectStatus = false;
    },
    // HAS ERROR
    hasError(state, action) {
      const { message } = action.payload?.data;
      state.createProjectStatus = false;
      state.isLoading = false;
      state.error = message;
    },
    // STATUS
    projectStatus(state, action) {
      state.isLoading = false;
      state.status = action.payload;
    },
    // GET PROJECT LIST
    getProjectListSuccess(state, action) {
      state.isLoading = false;
      state.projectList = action.payload;
    },
    // GET DISABLE PROJECT LIST
    getDisableProjectListSuccess(state, action) {
      state.isLoading = false;
      state.disableProjectList = action.payload;
    },
    // GET PROJECT LIST Header
    getClientListByProjectSuccess(state, action) {
      state.isLoading = false;
      const tempdata = action.payload;
      state.clientListByProject = tempdata.projects;
    },
    // // GET DISABLE PROJECT LIST Header
    // getDisableProjectListHeaderSuccess(state, action) {
    //   state.isLoading = false;
    //   state.disableProjectList = action.payload;
    // },
    // CREATE PROJECT
    createProjectSuccess(state, action) {
      const newProject = action.payload;
      state.createProjectStatus = true;
      state.isLoading = false;
      state.projectList = [...state.projectList, newProject];
    },
    // UPDATE PROJECT
    updateProjectSuccess(state, action) {
      const project = action.payload;
      state.createProjectStatus = true;
      const updateProject = map(state.projectList, (_project) => {
        if (_project.id === project.id) {
          return project;
        }
        return _project;
      });

      state.isLoading = false;
      state.projectList = updateProject;
    },
    // FILTER PROJECT
    filterProjectSuccess(state, action) {
      const project = action.payload;
      state.isLoading = false;
      if (state.status) {
        state.projectList = project;
      } else {
        state.disableProjectList = project;
      }
    },
    // DISABLE OR RESTORE PROJECT
    statusChangeSuccess(state, action) {
      if (action.payload.message) {
        state.projectMsg = action.payload.message;
      } else {
        const { id } = action.payload;
        const projectStatus = filter(
          state.status ? state.disableProjectList : state.projectList,
          (project) => project.id !== id
        );
        state.isLoading = false;
        if (state.status) {
          state.createProjectStatus = false;
          state.projectMsg = '';
          state.disableProjectList = projectStatus;
        } else {
          state.createProjectStatus = true;
          state.projectList = projectStatus;
        }
      }
    },
    // DELETE PROJECT
    deleteProjectSuccess(state, action) {
      const { id } = action.payload;
      const deleteEvent = filter(state.disableProjectList, (project) => project.id !== id);
      state.isLoading = false;
      state.disableProjectList = deleteEvent;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { resetCreateProjectStatus, resetProjectError, resetProjectMsg } = slice.actions;

// ----------------------------------------------------------------------

// GET PROJECT LIST GET
export function getProjectList(status) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/project/filter/item/?status=${status}`
      });
      if (status) {
        dispatch(slice.actions.getProjectListSuccess(response.data));
      } else {
        dispatch(slice.actions.getDisableProjectListSuccess(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// Project List Header
// /file-management-system/project/details/?project_id=2,3,4

export function getClientListByProject(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/file-management-system/project/details/?project_id=${id}`
      });
      if (id) {
        dispatch(slice.actions.getClientListByProjectSuccess(response?.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// CREATE PROJECT POST
export function createProject(projectData) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: 'http://smartcollect-api.cp360apps.com/project/',
        data: projectData
      });
      dispatch(slice.actions.createProjectSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// EDIT OR UPDATE PROJECT PUT
export function updateProject(projectData, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'put',
        url: `http://smartcollect-api.cp360apps.com/project/${id}/`,
        data: projectData
      });
      dispatch(slice.actions.updateProjectSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// SEARCH AND FILTER PROJECT GET
export function filterProject(pageStatus, name) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.projectStatus(pageStatus));
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/project/filter/item/?project_name=${name}&status=${pageStatus}`
      });
      dispatch(slice.actions.filterProjectSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// DISABLING AND RESTORING OF PARTICULAR PROJECT PUT
export function statusChange(id, status) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.projectStatus(status));
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'put',
        url: `http://smartcollect-api.cp360apps.com/project/update-status-${status}/${id}/`
      });
      dispatch(slice.actions.statusChangeSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// DELETE PROJECT DELETE
export function deleteProject(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'delete',
        url: `http://smartcollect-api.cp360apps.com/project/delete/${id}/`
      });
      dispatch(slice.actions.deleteProjectSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// ----------------------------------------------------------------------
